import {
  SHOW_JSON_COMPARE_MODAL,
  SHOW_JSON_COMPARE_MODAL_HIDE
} from 'Redux/actionTypes';

export const showJSONCompareModal = () => ({
  type: SHOW_JSON_COMPARE_MODAL,
  payload: {  }
});

export const showJSONCompareModalHide = () => ({
  type: SHOW_JSON_COMPARE_MODAL_HIDE,
  payload: {}
});